import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast, Toaster } from 'react-hot-toast';
import { BASE_URL } from '../BaseURL';
import '../Assets/Css/contact.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Container, Row, Col, Card, Form, Button, Spinner } from 'react-bootstrap';
import { IoIosSend } from 'react-icons/io';
// import chocolatebar from '../Assets/Image/contact-img.jpg';
import contact from '../Assets/Image/contact-img.jpg';
import contactbg from '../Assets/Image/contact-bg-img.avif';
import { Helmet } from 'react-helmet';


export default function Contact() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const [formData, setFormData] = useState({
    userName: '',
    email: '',
    mobile: '',
    address: '',
    message: '',
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    toast.loading("Sending your message...");

    try {
      const res = await axios.post(`${BASE_URL}/enquiry/sendContactEnquiry`, formData);
      toast.dismiss(); 
      toast.success(res.data.message || "Enquiry sent!");
      setFormData({
        userName: '',
        email: '',
        mobile: '',
        address: '',
        message: '',
      });
    } catch (error) {
      toast.dismiss();
      toast.error(error.response?.data?.error || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div >

<Helmet>
  <title>Contact Trident Software Services | Connect with Us</title>
  <meta name="description" content="Get in touch with Trident Software Services. Send us a message, find us on the map, and connect with our team for business and service inquiries." />
  <meta property="og:title" content="Connect with Trident Software Services" />
  <meta property="og:description" content="Send us a message or locate us on the map. We're here to help you grow with smart software solutions." />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://tridentsoftwareservice.com/contact" />
  <meta property="og:image" content="https://tridentsoftwareservice.com/images/contact-banner.jpg" />

  {/* Twitter Card */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Contact Trident Software Services" />
  <meta name="twitter:description" content="Reach out to Trident for custom software, ERP, CRM, and tech consulting solutions." />
  <meta name="twitter:image" content="https://tridentsoftwareservice.com/images/contact-twitter.jpg" />
</Helmet>

      <Toaster />

      <div className="container-fluid">
        <div className="row align-items-stretch">

          {/* Image Section (Always visible) */}
          <div className="col-md-6 p-0 position-relative">
            <img
              src={contact}
              alt="Chocolate Bar"
              className="contactimg"
              data-aos="zoom-in"
            />

            {/* Text overlay only for mobile */}
            <div className="text-overlay-mobile d-md-none d-flex flex-column align-items-center justify-content-center text-center">
              <h2 className="banner-heading-mobile" data-aos="zoom-in" >
                Connect with <br /> <span className="brand-name">Trident</span> Software Services
              </h2>
              {/* <p className="banner-subtext-mobile" data-aos="zoom-in" data-aos-delay="100">
         Experience the richness of handcrafted delight. Join us on our journey to bring premium, artisan chocolate right to your doorstep.
        </p> */}
              <a
                href="/contact"
              
                className="btn btn-banner mt-3"
                data-aos="zoom-in" data-aos-delay="100"
              >
                Get Involved
              </a>
            </div>
          </div>

          {/* Text Section for Desktop Only */}
          <div className="col-md-6 banner-text-section text-dark text-center text-md-start px-4 d-none d-md-flex align-items-center justify-content-center">
            <div className="row w-100">
              <div className="col-md-10 mx-auto leftdata">
                <h2 className="banner-heading" data-aos="zoom-in" >
                  Connect with
                </h2>
                <p> <span className="brand-name">Trident</span>
                  <span className='banner-heading1'>  Software Services</span>
                </p>


                {/* <p className="banner-subtext" data-aos="zoom-in" data-aos-delay="100">
  Experience the richness of handcrafted delight. Join us on our journey to bring premium, artisan chocolate right to your doorstep.
</p> */}
                <a
                   href="/contact"
                  className="btn btn-banner mt-4"
                  data-aos="zoom-in" data-aos-delay="200"
                >
                  Get Involved
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>


      {/* Contact Info Section with Floating Cards */}
      <Container className="py-5 mt-3 mb-3">
        <Row className="text-center mb-4" data-aos="zoom-in">
          <Col>
            <h3 className="fw-bold section-title">
              Get in Touch <span className="title-decoration"> </span>
            </h3>
          </Col>
        </Row>

        {/* <Row className="justify-content-center g-4 text-center">
          <Col md={4} data-aos="fade-up">
            <Card className="contactcard border-0 h-100 floating-card">
              <Card.Body>
                <a
                  href="https://wa.me/13122847077"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: 'none' }}
                >
                  <div className="titleclr">
                    <FaPhoneAlt size={40} />
                    <h5 className="mt-3">Phone</h5>
                  </div>
                </a>
                <p> +1 (312) 284-7077</p>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4} data-aos="fade-up" data-aos-delay="100">
            <Card className="contactcard border-0 h-100 floating-card">
              <Card.Body>
                <div className="titleclr">
                  <FaEnvelope size={40} />
                  <h5 className="mt-3">Email</h5>
                </div>
                <p>info@tridentsoftwareservice.com</p>
              </Card.Body>
            </Card>
          </Col>
        </Row> */}
      </Container>

      <section
        className="cta-section mb-4 d-flex align-items-center"
        style={{
          backgroundImage: `url(${contactbg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "100vh"
        }}
      >
        <Container className='p-4'>
          <Row className="justify-content-center">
            <Col md={8} className="contactform p-5" data-aos="zoom-in">
              <h4 className="titleclr fw-bold text-center">Send Us a Message</h4>
              <Form className="mt-3" onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formName">
                      <Form.Label>Your Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="userName"
                        placeholder="Enter your name"
                        value={formData.userName}
                        onChange={handleChange}
                        className="animated-input"
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formEmail">
                      <Form.Label>Email address</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        placeholder="Enter your email"
                        value={formData.email}
                        onChange={handleChange}
                        className="animated-input"
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formMobile">
                      <Form.Label>Mobile Number</Form.Label>
                      <Form.Control
                        type="text"
                        name="mobile"
                        placeholder="Enter your mobile number"
                        value={formData.mobile}
                        onChange={handleChange}
                        className="animated-input"
                        maxLength={10}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formAddress">
                      <Form.Label>Address</Form.Label>
                      <Form.Control
                        type="text"
                        name="address"
                        placeholder="Enter your address"
                        value={formData.address}
                        onChange={handleChange}
                        className="animated-input"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-3" controlId="formMessage">
                  <Form.Label>Your Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="message"
                    rows={4}
                    placeholder="Type your message here"
                    value={formData.message}
                    onChange={handleChange}
                    className="animated-input"
                  />
                </Form.Group>

                <div className="mt-3 d-flex justify-content-center">
                  <Button className="btn-banner" type="submit" disabled={loading}>
                    {loading ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-2" />
                        Sending...
                      </>
                    ) : (
                      <>
                        <IoIosSend className="fs-4 me-2" /> Send Message
                      </>
                    )}
                  </Button>
                </div>
              </Form>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Google Map Iframe Section */}
      <section className="map-section mt-5">
        <Container className="p-0">
          <Row className="text-center mb-4 m-0" data-aos="zoom-in">
            <Col>
              <h3 className="fw-bold section-title">Find Us on the Map
                <span className="title-decoration"> </span>
              </h3>
              <div className="section-underline mx-auto"></div>
            </Col>
          </Row>


          <iframe
            title="Trident Software Services"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2968.4266506346563!2d-87.63696108438874!3d41.87887627922108!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880e2cbe94f77599%3A0x946aa37e5a6f3f33!2sWillis%20Tower!5e0!3m2!1sen!2sus!4v1627648577806!5m2!1sen!2sus"
            width="100%"
            height="450"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade">
          </iframe>
        </Container>
      </section>
    </div>
  );
}
